import { render, staticRenderFns } from "./QuizModal.vue?vue&type=template&id=18ce3e1f&scoped=true"
import script from "./QuizModal.vue?vue&type=script&lang=js"
export * from "./QuizModal.vue?vue&type=script&lang=js"
import style0 from "./QuizModal.vue?vue&type=style&index=0&id=18ce3e1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ce3e1f",
  null
  
)

export default component.exports